import { all } from "redux-saga/effects";
import authSaga from "./authentication/authSaga";
import homeSaga from "./home/homeSaga";
export default function* rootSaga() {
  yield all([authSaga(), homeSaga()]);
}
